<template>
    <div class="main">
        <c-panel>
            <caixa :caixaInicial="caixaDaRota"></caixa>
        </c-panel>
    </div>
</template>
<script>

import caixa from "./caixa"

export default {
    computed: {
        caixaDaRota () {
            const p = this.$route.path
            if (p.indexOf('enviadas') >= 0)   return 'enviadas'
            if (p.indexOf('rascunhos') >= 0)  return 'rascunhos'
            if (p.indexOf('arquivadas') >= 0) return 'arquivadas'
            return 'entrada'
        }
    },
    components:{ caixa }
}
</script>
